import { Link } from 'react-router-dom'
import { useState } from 'react'
import MobileMenu from '../components/MobileMenu'
import SEO from '../components/SEO'

export default function Home() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  
  const navItems = [
    { path: '/artist', label: 'ARTIST' },
    { path: '/contacts', label: 'CONTACT' },
    { path: '/content', label: 'CONTENT' },
    { path: '/about', label: 'ABOUT US' }
  ]

  return (
    <main className="relative bg-black text-white min-h-screen overflow-hidden">
      <SEO 
        description="씨피엔터테인먼트(CP Entertainment)는 쿠팡의 자회사로, 아티스트 매니지먼트와 콘텐츠 제작을 전문으로 하는 엔터테인먼트 기업입니다. SNL 코리아, 직장인들 등 인기 콘텐츠 제작."
        path="/"
        keywords="cpent, cpentertainment, 씨피엔터테인먼트, CP Entertainment, 쿠팡엔터테인먼트, 씨피엔터, CPEnt, 쿠팡플레이, SNL 코리아, 직장인들, 신동엽, 이수지, 지예은, 김규원, 엔터테인먼트, 아티스트 매니지먼트, 콘텐츠 제작"
      />
      {/* Background Image with Overlays */}
      <div className="absolute inset-0" role="presentation">
        <img 
          src="/images/home-bg.png" 
          alt="CP Entertainment 배경 이미지" 
          className="w-full h-full object-cover"
        />
        {/* Gradient Overlay - from bottom (transparent) to top (black) */}
        <div 
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%)',
            opacity: 0.75
          }}
        />
        {/* Additional dark overlay */}
        <div className="absolute inset-0 bg-black/20" />
      </div>
      
      {/* Header - Desktop */}
      <header className="relative hidden md:block">
        <div className="flex h-[100px] px-8 justify-center items-center">
          <div className="flex w-full max-w-[1216px] justify-between items-center">
            {/* Empty left side for balance */}
            <div className="flex-1" />
            
            {/* Navigation - centered */}
            <nav className="flex items-center gap-10">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="hover:opacity-80 transition-opacity"
                  style={{ 
                    color: '#FFF',
                    textAlign: 'center',
                    fontFamily: 'Pretendard',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: '145%',
                    letterSpacing: '-0.08px',
                    textTransform: 'uppercase'
                  }}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
            
            {/* Empty right side for balance */}
            <div className="flex-1" />
          </div>
        </div>
      </header>
      
      {/* Header - Mobile */}
      <header className="relative md:hidden">
        <div className="flex h-[68px] px-4 justify-between items-center">
          <Link to="/">
            <img 
              src="/images/logo-white.svg" 
              alt="Coupang Play Logo" 
              className="h-5"
            />
          </Link>
          
          <button
            onClick={() => setIsMobileMenuOpen(true)}
            className="w-12 h-12 flex items-center justify-center"
            aria-label="Menu"
          >
            <img 
              src="/images/mobile-menu-white.svg" 
              alt="Menu"
              className="w-7 h-3"
            />
          </button>
        </div>
      </header>
      
      {/* Mobile Menu */}
      <MobileMenu 
        isOpen={isMobileMenuOpen} 
        onClose={() => setIsMobileMenuOpen(false)}
        navItems={navItems}
      />
      
      {/* Content */}
      <section className="relative max-w-[1280px] mx-auto px-4 md:px-8 pb-8 md:pb-[100px]">
        {/* Mobile: 55% from top positioning */}
        <div className="md:hidden" style={{ paddingTop: 'calc(55vh - 68px - 100px)' }}></div>
        
        <div className="max-w-[1216px] mx-auto flex flex-col items-center">         
          {/* Logo */}
          <h1 className="w-full flex items-center justify-center">
            <span className="sr-only">씨피엔터테인먼트 (CP Entertainment) - 쿠팡플레이 아티스트 매니지먼트 & 콘텐츠 제작</span>
            {/* Mobile Logo */}
            <img
              src="/images/home/logo_mobile.svg"
              alt="씨피엔터테인먼트 로고"
              className="h-auto md:hidden"
            />
            {/* Desktop Logo */}
            <img
              src="/images/logo-white.svg"
              alt="씨피엔터테인먼트 로고"
              className="h-auto hidden md:block"
              style={{
                marginTop: '76.45px'
              }}
            />
          </h1>
          
          {/* Contact Info */}
          <address className="w-full flex flex-col items-center justify-center gap-1 md:gap-2 text-center not-italic" style={{ marginTop: '20px' }}>
            <div className="flex flex-row items-center justify-center gap-1 md:gap-2">
              <p 
                className="md:hidden"
                style={{
                  color: 'rgba(255, 255, 255, 0.80)',
                  fontFamily: 'Pretendard',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: '140%',
                  letterSpacing: '-0.21px'
                }}
              >
                섭외/제작 문의
              </p>
              <p 
                className="hidden md:block"
                style={{
                  color: '#FFF',
                  fontFamily: 'Pretendard',
                  fontSize: '18px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: '140%',
                  letterSpacing: '-0.27px'
                }}
              >
                섭외/제작 문의
              </p>
              
              <p 
                className="md:hidden"
                style={{
                  color: 'rgba(255, 255, 255, 0.80)',
                  fontFamily: 'Pretendard',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '140%',
                  letterSpacing: '-0.21px'
                }}
              >
                management@cpent.com
              </p>
              <p 
                className="hidden md:block"
                style={{
                  color: '#FFF',
                  fontFamily: 'Pretendard',
                  fontSize: '18px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '140%',
                  letterSpacing: '-0.27px'
                }}
              >
                management@cpent.com
              </p>
            </div>
            <div className="flex flex-row items-center justify-center gap-1 md:gap-2">
              <p 
                className="md:hidden"
                style={{
                  color: 'rgba(255, 255, 255, 0.80)',
                  fontFamily: 'Pretendard',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: '140%',
                  letterSpacing: '-0.21px'
                }}
              >
                제보 및 신고
              </p>
              <p 
                className="hidden md:block"
                style={{
                  color: '#FFF',
                  fontFamily: 'Pretendard',
                  fontSize: '18px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: '140%',
                  letterSpacing: '-0.27px'
                }}
              >
                제보 및 신고
              </p>
              
              <p 
                className="md:hidden"
                style={{
                  color: 'rgba(255, 255, 255, 0.80)',
                  fontFamily: 'Pretendard',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '140%',
                  letterSpacing: '-0.21px'
                }}
              >
                report@cpent.com
              </p>
              <p 
                className="hidden md:block"
                style={{
                  color: '#FFF',
                  fontFamily: 'Pretendard',
                  fontSize: '18px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '140%',
                  letterSpacing: '-0.27px'
                }}
              >
                report@cpent.com
              </p>
            </div>
          </address>
          
          {/* Poster Section - Desktop */}
          <div className="w-full hidden md:flex items-center justify-center" style={{ marginTop: '40px' }}>
            <div className="relative w-[1216px] h-[397px] flex items-center justify-center">
              {/* Poster 1 */}
              <div className="absolute left-0 w-[278px] h-[397px] overflow-hidden shadow-2xl hover:scale-105 transition-transform duration-300 z-0">
                <img 
                  src="/images/home/poster-1.png" 
                  alt="쿠팡플레이 코미디 쇼 SNL 코리아 시즌 8 포스터"
                  className="w-full h-full object-cover"
                  style={{ aspectRatio: '278/397' }}
                />
              </div>

              {/* Poster 2 */}
              <div className="absolute left-[246px] w-[278px] h-[397px] overflow-hidden shadow-2xl hover:scale-105 transition-transform duration-300 z-10">
                <img
                  src="/images/home/poster-2.png"
                  alt="쿠팡플레이 예능 자매치킨 포스터"
                  className="w-full h-full object-cover"
                  style={{ aspectRatio: '278/397' }}
                />
              </div>

              {/* Poster 3 */}
              <div className="absolute left-[492px] w-[278px] h-[397px] overflow-hidden shadow-2xl hover:scale-105 transition-transform duration-300 z-20">
                <img
                  src="/images/home/poster-3.png"
                  alt="쿠팡플레이 예능 자매다방 포스터"
                  className="w-full h-full object-cover"
                  style={{ aspectRatio: '278/397' }}
                />
              </div>

              {/* Poster 4 */}
              <div className="absolute left-[738px] w-[278px] h-[397px] overflow-hidden shadow-2xl hover:scale-105 transition-transform duration-300 z-10">
                <img
                  src="/images/home/poster-4.png"
                  alt="쿠팡플레이 코미디 쇼 SNL 코리아 포스터"
                  className="w-full h-full object-cover"
                  style={{ aspectRatio: '278/397' }}
                />
              </div>

              {/* Poster 5 */}
              <div className="absolute left-[984px] w-[278px] h-[397px] overflow-hidden shadow-2xl hover:scale-105 transition-transform duration-300 z-0">
                <img
                  src="/images/home/poster-5.png"
                  alt="쿠팡플레이 시리즈 직장인들 포스터" 
                  className="w-full h-full object-cover"
                  style={{ aspectRatio: '278/397' }}
                />
              </div>
            </div>
          </div>
          
        </div>
      </section>
    </main>
  )
}
